import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/shared/lib/supabase'
import { useCurrentUser } from '@/features/auth/hooks/use-current-user'
import type { UserRole } from '@/shared/types'

interface UpdateUserRoleData {
  userId: string
  newRole: UserRole
}

async function updateUserRole(data: UpdateUserRoleData): Promise<void> {
  const { error } = await supabase.rpc('update_user_role', {
    p_user_id: data.userId,
    p_new_role: data.newRole,
  })

  if (error) {
    // Map specific errors
    if (error.message.includes('Cannot change your own role')) {
      throw new Error('CANNOT_CHANGE_OWN_ROLE')
    }
    if (error.message.includes('Only admins')) {
      throw new Error('NOT_ADMIN')
    }
    throw new Error(error.message)
  }
}

export function useUpdateUserRole() {
  const queryClient = useQueryClient()
  const { user } = useCurrentUser()

  return useMutation({
    mutationFn: updateUserRole,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizationUsers', user?.organization_id] })
    },
  })
}
